import React, { FC } from "react";

type Props = {
  children?: React.ReactNode
}

export const CentralContent: FC<Props> = ({children}) => {
  return <div className="flex justify-center mx-auto min-w-[320px] max-w-screen-sm w-full px-4">
      {children}
  </div>
};